import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const DASHBOARD_LIST_CONTENT_SCHEMA = Object.freeze({
  LABEL: '',
  SUB_LABEL: null, // string
  TOTAL: 0,
  URL: null, // string
  FG_COLOR: null, // string
});
const RECORD = generateSchema(DASHBOARD_LIST_CONTENT_SCHEMA);
const KEYS: any = generateKeys(DASHBOARD_LIST_CONTENT_SCHEMA);

export class DashboardListContent extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get subLabel(): string {
    return this.get(KEYS.SUB_LABEL);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }

  get url(): string {
    return this.get(KEYS.URL);
  }

  get fgColor(): string {
    return this.get(KEYS.FG_COLOR);
  }
}
